import { createGlobalStyle } from 'styled-components';
import img from './makise.jpg';

const HomeStyle = createGlobalStyle`
body {
    background: url(${img}) no-repeat center center fixed;  
    background-size: cover;
    font-family: Arial, sans-serif;
    background-color: #0a0a0a;
    color: #00ff41;
    font-size: 18px;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

/* Home Container */
.home-container {
    flex-grow: 1;
    padding: 2rem 1rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    animation: fadein 1s ease-in-out;
}

/* Hero Card - Cyberpunk Style */
.hero-card {
    margin: 2rem auto 1.5rem;
    padding: 0.5rem;
    background: linear-gradient(135deg, rgba(10, 10, 10, 0.95) 0%, rgba(20, 20, 30, 0.95) 100%) !important;
    border: 2px solid #00ff41 !important;
    box-shadow: 20px 20px 20px rgba(0, 255, 65, 0.3), 10px 10px 20px rgba(0, 255, 255, 0.3) !important;
    animation: electricbox 0.8s infinite, shadow-move 4s infinite alternate, fadein 1s ease-in-out;
    transition: box-shadow 0.3s ease-in-out;
    backdrop-filter: blur(10px);
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

.hero-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(0, 255, 65, 0.03) 2px,
        rgba(0, 255, 65, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
}

@keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
}

.hero-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 0 40px rgba(0, 255, 65, 0.6), inset 0 0 30px rgba(0, 255, 65, 0.2) !important;
    border-color: #00ffff !important;
}

.hero-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.hero-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 2rem;
    color: #00ff41;
    text-shadow: 0 0 10px rgba(0, 255, 65, 0.8), 0 0 20px rgba(0, 255, 65, 0.4);
    font-family: Arial, sans-serif;
    font-weight: bold;
    letter-spacing: 2px;
}

.hero-icon {
    width: 2rem;
    height: 2rem;
    color: #00ffff;
    animation: electric 0.8s infinite, rotate-pulse 3s ease-in-out infinite;
    filter: drop-shadow(0 0 10px rgba(0, 255, 255, 0.8));
}

@keyframes rotate-pulse {
    0%, 100% { transform: rotate(0deg) scale(1); }
    50% { transform: rotate(180deg) scale(1.1); }
}

.hero-badge {
    background: linear-gradient(135deg, #00ff41 0%, #00ffff 100%);
    color: #000;
    font-weight: bold;
    font-family: Arial, sans-serif;
    animation: electric 0.8s infinite;
    box-shadow: 0 0 10px rgba(0, 255, 65, 0.8);
    border: 1px solid #00ffff;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.hero-content {
    font-size: 1.25rem;
    position: relative;
}

.hero-text {
    color: #00ff41;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.8;
    margin-bottom: 1rem;
    text-shadow: 0 0 5px rgba(0, 255, 65, 0.5);
    font-family: Arial, sans-serif;
}

.hero-link {
    color: #00ffff;
    font-weight: bold;
    text-decoration: none;
    transition: all 0.3s ease;
    text-shadow: 0 0 5px rgba(0, 255, 255, 0.8);
    border-bottom: 2px solid #00ffff;
}

.hero-link:hover {
    color: #ff00ff;
    text-shadow: 0 0 10px rgba(255, 0, 255, 0.8);
    border-bottom-color: #ff00ff;
}

/* Announcements Card - Cyberpunk Green Style */
.announcements-card {
    margin: 1.5rem auto;
    padding: 2rem;
    background: linear-gradient(135deg, rgba(10, 10, 10, 0.95) 0%, rgba(10, 20, 10, 0.95) 100%) !important;
    border: 2px solid #00ff41 !important;
    box-shadow: 20px 20px 20px rgba(0, 255, 65, 0.3), 10px 10px 20px rgba(0, 255, 255, 0.3) !important;
    animation: electricbox 5s infinite alternate, shadow-move 4s infinite alternate, fadein 1s ease-in-out;
    transition: box-shadow 0.3s ease-in-out;
    backdrop-filter: blur(10px);
    position: relative;
    box-sizing: border-box;
}

.announcements-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: none;
    pointer-events: none;
}

.announcements-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 0 40px rgba(0, 255, 65, 0.5), inset 0 0 30px rgba(0, 255, 65, 0.2) !important;
    border-color: #00ffff !important;
}

.announcements-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 1.75rem;
    color: #00ff41;
    text-shadow: 0 0 10px rgba(0, 255, 65, 0.8);
    font-family: Arial, sans-serif;
    font-weight: bold;
    letter-spacing: 2px;
    position: relative;
    z-index: 1;
    margin-bottom: 1.5rem;
}

.announcements-icon {
    width: 1.75rem;
    height: 1.75rem;
    color: #00ffff;
    animation: electric 0.8s infinite;
    filter: drop-shadow(0 0 10px rgba(0, 255, 255, 0.8));
}

.announcements-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    z-index: 1;
}

.announcement-alert {
    background: rgba(10, 10, 10, 0.8);
    border-left: 4px solid #00ff41;
    border-right: 1px solid rgba(0, 255, 65, 0.3);
    border-top: 1px solid rgba(0, 255, 65, 0.2);
    border-bottom: 1px solid rgba(0, 255, 65, 0.2);
    animation: fadein 0.8s ease-in-out;
    box-shadow: 0 0 10px rgba(0, 255, 65, 0.2);
    color: #00ff41;
    padding: 1.5rem;
    margin-bottom: 1rem;
    text-align: center !important;
}

.announcement-alert * {
    text-align: center !important;
}

.announcement-alert [class*="AlertTitle"] {
    color: #00ffff !important;
    font-family: Arial, sans-serif !important;
    font-weight: bold !important;
    text-shadow: 0 0 5px rgba(0, 255, 255, 0.5) !important;
    letter-spacing: 1px !important;
    margin-bottom: 0.75rem !important;
    font-size: 1.1rem !important;
    text-align: center !important;
    padding: 0.5rem 0 !important;
    display: block !important;
    width: 100% !important;
}

.announcement-alert [class*="AlertDescription"] {
    color: #00ff41 !important;
    font-family: Arial, sans-serif !important;
    line-height: 1.6 !important;
    font-size: 1rem !important;
    text-align: center !important;
    font-weight: 600 !important;
    padding: 0.5rem 0 !important;
    display: block !important;
    width: 100% !important;
}

.announcement-separator {
    background: linear-gradient(90deg, transparent, #00ff41, #00ffff, #00ff41, transparent);
    height: 2px;
    box-shadow: 0 0 10px rgba(0, 255, 65, 0.5);
    margin: 2rem 0;
}

.inline-link {
    color: #00ffff;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    border-bottom: 1px solid #00ffff;
}

.inline-link:hover {
    color: #ff00ff;
    border-bottom-color: #ff00ff;
    text-shadow: 0 0 5px rgba(255, 0, 255, 0.8);
}

.resources-section {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: 2rem;
    background: linear-gradient(135deg, rgba(0, 255, 65, 0.05) 0%, rgba(0, 255, 255, 0.05) 100%);
    border-radius: 0.5rem;
    border: 2px solid rgba(0, 255, 65, 0.3);
    box-shadow: inset 0 0 20px rgba(0, 255, 65, 0.1);
    box-sizing: border-box;
    margin-top: 1rem;
}

.resources-title {
    font-size: 1.25rem;
    font-weight: bold;
    color: #00ffff;
    margin-bottom: 0.75rem;
    font-family: Arial, sans-serif;
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.8);
    letter-spacing: 2px;
    text-transform: uppercase;
}

.resources-note {
    color: #00ff41;
    font-size: 1rem;
    line-height: 1.8;
    margin: 0.75rem 0;
    font-family: Arial, sans-serif;
}

.resource-button {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: flex-start;
    transition: all 0.3s ease;
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #00ff41;
    color: #00ff41;
    font-weight: 600;
    font-family: Arial, sans-serif;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 0 10px rgba(0, 255, 65, 0.3);
    padding: 1rem 1.5rem;
    border-radius: 0.5rem;
}

.resource-button:hover {
    background: linear-gradient(135deg, rgba(0, 255, 65, 0.2) 0%, rgba(0, 255, 255, 0.2) 100%);
    color: #00ffff;
    border-color: #00ffff;
    transform: translateX(10px);
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.6), inset 0 0 10px rgba(0, 255, 255, 0.2);
}

.button-icon {
    width: 1.25rem;
    height: 1.25rem;
    filter: drop-shadow(0 0 5px currentColor);
}

.external-links {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

/* Keep Original Animations */
@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        filter: drop-shadow(0 0 5px currentColor);
    }
    50% {
        text-shadow: 0 0 10px currentColor, 0 0 20px currentColor;
        filter: drop-shadow(0 0 15px currentColor);
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        filter: drop-shadow(0 0 5px currentColor);
    }
}

@keyframes electricbox {
    0% {
        box-shadow: 0 0 10px rgba(0, 255, 65, 0.3), inset 0 0 10px rgba(0, 255, 65, 0.1);
    }
    50% {
        box-shadow: 0 0 30px rgba(0, 255, 65, 0.6), inset 0 0 20px rgba(0, 255, 65, 0.2);
    }
    100% {
        box-shadow: 0 0 10px rgba(0, 255, 65, 0.3), inset 0 0 10px rgba(0, 255, 65, 0.1);
    }
}

@keyframes shadow-move {
    0% {
        box-shadow: 0 0 0 rgba(0, 255, 65, 0.4), 0 0 20px rgba(0, 255, 255, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(255, 0, 255, 0.4), 0 0 20px rgba(0, 255, 65, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(0, 255, 255, 0.4), 0 0 20px rgba(255, 0, 255, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(0, 255, 65, 0.4), 0 0 20px rgba(0, 255, 255, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(255, 0, 255, 0.4), 0 0 20px rgba(0, 255, 65, 0.4);
    }
}

@keyframes fadein {
    from {
        transform: translateY(-50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Server Status Styles - Cyberpunk */
.server-status {
    border: 3px solid #00ff41;
    border-radius: 5px;
    padding: 1.25rem;
    max-width: 300px;
    width: 100%;
    margin: 2rem auto;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 255, 65, 0.4), inset 0 0 20px rgba(0, 255, 65, 0.1);
    animation: electricbox 5s infinite alternate, fadein 1s ease-in-out;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(10, 20, 10, 0.9) 100%);
    backdrop-filter: blur(10px);
    box-sizing: border-box;
}

.server-status hserv {
    font-size: 18px;
    margin-bottom: 10px;
    text-align: center;
    color: #00ffff;
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.8);
    justify-content: center;
    animation: electric 0.8s infinite;
    font-style: normal;
    font-family: Arial, sans-serif;
    font-weight: bold;
    letter-spacing: 2px;
}

.server-status pserv {
    font-size: 12px;
    font-family: Arial, sans-serif;
    margin-right: 5px;
    font-weight: bold;
    text-align: center;
    color: #00ff41;
}

.server-status .lamp {
    width: 20px;
    height: 30px;
    border-radius: 50%;
    margin-right: 5px;
    display: inline-block;
    font-weight: bold;
    font-size: 20px;
}

.server-status .loading {
    color: #888;
}

.server-status .online {
    color: #00ff41;
    animation: glow 1s ease-in-out infinite alternate;
    text-align: center;
}

.server-status .offline {
    color: #ff0055;
    animation: glowoff 0.5s ease-in-out infinite alternate;
    text-align: center;
}

@keyframes glow {
    from {
        text-shadow: 0 0 5px #00ff41, 0 0 10px #00ff41, 0 0 15px #00ff41;
    }
    to {
        text-shadow: 0 0 10px #00ff41, 0 0 20px #00ff41, 0 0 30px #00ff41, 0 0 40px #00ff41;
    }
}

@keyframes glowoff {
    from {
        text-shadow: 0 0 5px #ff0055, 0 0 10px #ff0055;
    }
    to {
        text-shadow: 0 0 10px #ff0055, 0 0 20px #ff0055, 0 0 30px #ff0055;
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .home-container {
        padding: 1rem 0.75rem;
    }

    .hero-card {
        margin: 1rem auto 1rem;
        padding: 1.5rem;
    }

    .announcements-card {
        margin: 1rem auto;
        padding: 1.5rem;
    }

    .hero-title {
        font-size: 1.25rem;
    }

    .hero-text {
        font-size: 1rem;
    }

    .announcements-title {
        font-size: 1.25rem;
        margin-bottom: 1rem;
    }

    .announcements-content {
        gap: 1.5rem;
    }

    .announcement-alert {
        padding: 1rem;
    }

    .announcement-separator {
        margin: 1.5rem 0;
    }

    .resource-button {
        font-size: 0.875rem;
        padding: 0.875rem 1.25rem;
    }

    .external-links {
        gap: 0.75rem;
    }

    .resources-section {
        padding: 1.5rem;
        gap: 1rem;
    }

    .server-status {
        margin: 1.5rem auto;
        padding: 1rem;
    }
}

/* Nav Menu Hover Effects - Home Page Specific */
nav ul li a, nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
    color: #00ff41;
    text-shadow: 1px 1px 2px #00ff41, 0 0 1em #00ff41, 0 0 0.2em #00ffff;
    transition: text-shadow 0.3s ease;
    animation: electric 0.8s infinite;
}
`;

export default HomeStyle;